import React, { Component } from "react";
import Axios from "axios";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

import { url } from "../../../../../config/config";
import { withRouter } from "react-router-dom";
import { useStyles } from "./SimilarGenreBooks.css";

class SimilarGenreBooks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      similarBooks: [],
    };
  }

  UNSAFE_componentWillReceiveProps() {
    if (this.props.bookData.length !== 0)
      this.getBooks(this.props.bookData.genre);
  }

  getBooks = async (genre) => {
    const response = await Axios.get(`${url}/api/books`, {
      params: {
        genre: genre,
      },
    });
    if (response.data) {
      let tempData = response.data.filter(
        (book) => book._id !== this.props.bookData._id
      );
      if (tempData.length !== 0) {
        this.setState({
          similarBooks: tempData,
        });
      } else {
        this.setState({ similarBooks: [] });
      }
    }
  };

  handleBook = (bookId) => {
    this.props.history.push(`/books/details/${bookId}`);
  };

  render() {
    const { classes } = this.props;
    return (
      this.state.similarBooks.length !== 0 && (
        <div className={classes.root}>
          {this.state.similarBooks.length !== 0 ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div style={{ fontSize: 30 }}>Books of similar genre</div>
              <Grid container spacing={3} className={classes.gridContainer}>
                {this.state.similarBooks.slice(0, 4).map((book, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    xl={4}
                    lg={4}
                    key={index}
                    className={classes.gridItem}
                  >
                    <Paper className={classes.bookItem}>
                      <div
                        className={classes.bookCoverStyle}
                        onClick={() => this.handleBook(book._id)}
                      >
                        <img
                          src={book.bookCoverUrl}
                          alt="BookCoverImage"
                          className={classes.coverImageStyle}
                        />
                      </div>
                      <div className={classes.bookBody}>
                        <div>
                          <div style={{ fontSize: 24, fontWeight: "bold" }}>
                            {book.title}
                          </div>
                          <div style={{ fontSize: 20, color: "grey" }}>
                            By {book.author.firstName} {book.author.lastName}
                          </div>
                        </div>
                      </div>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </div>
          ) : null}
        </div>
      )
    );
  }
}

export default withStyles(useStyles)(withRouter(SimilarGenreBooks));
